import { RequirementReport } from "../../hooks/DownLoadExcel/RequirementReport";
import { apiFetch } from "./fetchApi";

// export const fetchRequirement = async ({
//     BeURL,
//     setRequirement,
//     showAlert,
//     currentPage,
//     rowsPerPage,
//     setTotal,
//     setTotalPage,
//     setPerPageTotal,
//     activeIndex = "All",
//     fromDate,
//     toDate,
//     id,
//     type,
//     currentUser
// }) => {
//     try {
//         const queryParams = new URLSearchParams({
//             page: currentPage,
//             limit: rowsPerPage,
//             id: id || "",
//             type
//         });
//         if (activeIndex) {
//             queryParams.append("value", activeIndex);
//         }

//         if (fromDate && toDate) {
//             queryParams.append("fromDate", fromDate);
//             queryParams.append("toDate", toDate);
//         }
//         apiFetch(`${BeURL}/fetch-requirement?${queryParams.toString()}`, {
//             method: "GET",
//             credentials: "include",
//         })
//             .then(res => res.json())
//             .then(data => {
//                 if (data.success) {
//                     if (type === "excel") {
//                         RequirementReport({ requirement: data.requirement, showAlert, currentUser })
//                     }
//                     setRequirement(data.requirement || []);
//                     setTotal(data.total);
//                     setTotalPage(data.totalPage);
//                     setPerPageTotal(data.perPageTotal)
//                 } else {
//                     showAlert?.(data.message);
//                 }
//             })
//             .catch(err => {
//                 console.error("Error in fetchRequirement:", err);
//             })




//     } catch (err) {
//         console.error("Error in fetchRequirement:", err);
//         showAlert?.("Failed to fetch Requirement", "error");
//     }
// };


// Copy of  Recruitment Report
export const fetchRecruitment = async ({
    BeURL,
    setRequirement,
    showAlert,
    currentPage,
    rowsPerPage,
    setTotal,
    setTotalPage,
    setPerPageTotal,
    activeIndex,
    fromDate,
    toDate,
    id,
    type,
    currentUser,
    clientId,
    managerId,
    teamleadId,
    recruiterId,
    statusId
}) => {
    try {
        const queryParams = new URLSearchParams({
            page: currentPage,
            limit: rowsPerPage,
            id: id || "",
            type,

        });
        if (activeIndex) {
            queryParams.append("value", activeIndex);
        }

        if (fromDate || toDate) {
            queryParams.append("fromDate", fromDate);
            queryParams.append("toDate", toDate);
        }

        if (clientId) {
            queryParams.append("clientId", clientId)
        }
        if (managerId) {
            queryParams.append("managerId", managerId)
        }
        if (teamleadId) {
            queryParams.append("teamLeadId", teamleadId)
        }
        if (recruiterId) {
            queryParams.append("recruiterId", recruiterId)
        }
        if (statusId) {
            queryParams.append("statusId", statusId)
        }

        apiFetch(`${BeURL}/fetch-recruitementReport?${queryParams.toString()}`, {
            method: "GET",
            credentials: "include",
        })
            .then(res => res.json())
            .then(data => {
                console.log("fetchRecruitment data:", data);
                if (data.success) {

                    if (type === "excel") {
                        RequirementReport({ requirement: data.requirement, showAlert, currentUser })
                    }
                    else {
                        setRequirement(data.requirement || []);
                        setTotal(data.total);
                        setTotalPage(data.totalPage);
                        setPerPageTotal(data.perPageTotal)
                    }
                } else {
                    console.log("triggered:", data)
                    showAlert(data.message);
                }
            })
            .catch(err => {
                console.error("Error in fetchRequirement:", err);
            })




    } catch (err) {
        console.error("Error in fetchRequirement:", err);
        showAlert("Failed to fetch Requirement", "error");
    }
};


export const fetchRecruitmentTableFilter = async ({
    BeURL,
    setRequirement,
    showAlert,
    currentPage,
    rowsPerPage,
    setTotal,
    setTotalPage,
    setPerPageTotal,
    activeIndex,
    fromDate,
    toDate,
    id,
    type,
    currentUser,
    clientId,
    managerId,
    teamleadId,
    recruiterId,
    clientManager,
    updatedByRecruiterId,
    jobName,
    candidateName,
    mobileNumber, emailId,
    jobStatus,
    // empId,
    sanSpocId,
    statusId,
    scheduledDate, joinedDate,
    submittedOn
}) => {
    try {
        // console.log("ScheduledDate:::::", scheduledDate)
        const queryParams = new URLSearchParams({
            page: currentPage,
            limit: rowsPerPage,
            id: id || "",
            type,

        });
        if (activeIndex) {
            queryParams.append("value", activeIndex);
        }

        if (fromDate || toDate) {
            queryParams.append("fromDate", fromDate);
            queryParams.append("toDate", toDate);
        }

        if (clientId) {
            queryParams.append("clientId", clientId)
        }
        if (managerId) {
            queryParams.append("managerId", managerId)
        }
        if (teamleadId) {
            queryParams.append("teamLeadId", teamleadId)
        }
        if (recruiterId) {
            queryParams.append("recruiterId", recruiterId)
        }

        if (updatedByRecruiterId) {
            queryParams.append("updatedByrecruiterId", updatedByRecruiterId)
        }

        if (sanSpocId) {
            queryParams.append("sanSpocId", sanSpocId)
        }

        if (jobName) {
            queryParams.append("jobName", jobName)
        }
        if (candidateName) {
            queryParams.append("candidateName", candidateName.trim())
        }

        if (clientManager) {
            queryParams.append("clientManager", clientManager.trim())
        }

        if (mobileNumber) {
            queryParams.append("mobileNumber", mobileNumber.trim())
        }

        if (emailId) {
            queryParams.append("emailAddress", emailId.trim())
        }

        if (jobStatus) {
            queryParams.append("jobStatus", jobStatus.trim())
        }

        // if (empId) {
        //     queryParams.append("empId", empId.trim())
        // }

        if (statusId.length > 0) {

            statusId.forEach(ids => {
                queryParams.append("statusId", ids)

            });
        }

        if (scheduledDate.from) {
            queryParams.append("scheduledFromDate", scheduledDate.from)
        }

        if (scheduledDate.to) {
            queryParams.append("scheduledToDate", scheduledDate.to)
        }

        if (joinedDate.from) {
            queryParams.append("joinedFromDate", joinedDate.from)
        }

        if (joinedDate.to) {
            queryParams.append("joinedToDate", joinedDate.to)
        }

        if (submittedOn.from) {
            queryParams.append("submittedFromDate", submittedOn.from)
        }

        if (submittedOn.to) {
            queryParams.append("submittedToDate", submittedOn.to)
        }

        if (!(jobName.trim() || emailId.trim() || mobileNumber.trim() || candidateName.trim())) {
            await new Promise(resolve => setTimeout(resolve, 0));
        }

        apiFetch(`${BeURL}/fetch-recruitementTableFilterReport?${queryParams.toString()}`, {
            method: "GET",
            credentials: "include",
        })
            .then(res => res.json())
            .then(data => {
                // console.log("fetchRecruitment data:", data);
                if (data.success) {

                    if (type === "excel") {
                        RequirementReport({ requirement: data.requirement, showAlert, currentUser })
                    }
                    else {
                        setRequirement(data.requirement || []);
                        setTotal(data.total);
                        setTotalPage(data.totalPage);
                        setPerPageTotal(data.perPageTotal)
                    }
                } else {
                    console.log("triggered:", data)
                    showAlert(data.message);
                }



            })
            .catch(err => {
                console.error("Error in fetchRequirement:", err);

            })



    } catch (err) {
        console.error("Error in fetchRequirement:", err);
        showAlert("Failed to fetch Requirement", "error");
    }
};



// Fetch EmpId those which Candidate get it fetch
// export const fetchCandidateEmpId = async (BeURL, showAlert, setEmpIdLists) => {
//     try {
//         console.log("Emp Lists are called")
//         // 2️⃣ Send companyId as param for get manager Ids creation
//         const res = await apiFetch(`${BeURL}/fetchPofileActionEmpId`, {
//             method: "GET",
//         });

//         const data = await res.json();
//         if (!data.success) {
//             showAlert(data.message);
//             return;
//         }

//         setEmpIdLists(data.empIds.map(e => e.empId));
//         console.log("All EmpId are used",data.empIds)

//     } catch (err) {
//         console.error("Error in Fetch All Candidate EmpId:", err);
//         alert('Trouble connecting to the server! Please try again later.');
//     }
// }